import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import "./MatchReasonsPopover.scss";

const MatchReasonsPopover = ({ reasons, score, children, placement = "bottom" }) => {
  const safeChildren = children || null;

  if (!reasons || (!reasons.matched?.length && !reasons.partial?.length && !reasons.missing?.length && !reasons.must_haves_matched?.length && !reasons.must_haves_missing?.length)) {
    return safeChildren;
  }

  const popover = (
    <Popover className="match-reasons-popover">
      <Popover.Header className="match-reasons-popover__header">
        {typeof score === "number" && (
          <span className="match-reasons-popover__score">{score}%</span>
        )}
        <span className="match-reasons-popover__summary">{reasons.summary}</span>
      </Popover.Header>
      <Popover.Body className="match-reasons-popover__body">
        {reasons.matched?.length > 0 && (
          <ul className="match-reasons-popover__list match-reasons-popover__list--matched">
            {reasons.matched.map((r, i) => (
              <li key={`m-${i}`}>
                <span className="match-reasons-popover__icon">✓</span>
                <span>{r.text}</span>
              </li>
            ))}
          </ul>
        )}

        {reasons.must_haves_matched?.length > 0 && (
          <div className="match-reasons-popover__chip-section">
            <p className="match-reasons-popover__chip-label">They want, you have:</p>
            <div className="match-reasons-popover__chips">
              {reasons.must_haves_matched.map((label, i) => (
                <span key={`mh-${i}`} className="match-reasons-popover__chip match-reasons-popover__chip--yes">
                  {label}
                </span>
              ))}
            </div>
          </div>
        )}

        {reasons.partial?.length > 0 && (
          <ul className="match-reasons-popover__list match-reasons-popover__list--partial">
            {reasons.partial.map((r, i) => (
              <li key={`p-${i}`}>
                <span className="match-reasons-popover__icon">~</span>
                <span>{r.text}</span>
              </li>
            ))}
          </ul>
        )}

        {reasons.must_haves_missing?.length > 0 && (
          <div className="match-reasons-popover__chip-section">
            <p className="match-reasons-popover__chip-label">They want, you don't have:</p>
            <div className="match-reasons-popover__chips">
              {reasons.must_haves_missing.map((label, i) => (
                <span key={`mhm-${i}`} className="match-reasons-popover__chip match-reasons-popover__chip--no">
                  {label}
                </span>
              ))}
            </div>
          </div>
        )}

        {reasons.missing?.length > 0 && (
          <ul className="match-reasons-popover__list match-reasons-popover__list--missing">
            {reasons.missing.map((r, i) => (
              <li key={`x-${i}`}>
                <span className="match-reasons-popover__icon">✗</span>
                <span>{r.text}</span>
              </li>
            ))}
          </ul>
        )}
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: 150, hide: 200 }}
      overlay={popover}
    >
      <span className="match-reasons-popover__trigger">{safeChildren}</span>
    </OverlayTrigger>
  );
};

export default MatchReasonsPopover;
